import React from 'react';

import { GlobalOutlined, CheckOutlined, DownOutlined } from '@ant-design/icons';
import { Button, Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import { useTranslation } from 'react-i18next';

import { LANGUAGE_OPTIONS, getLanguageOption } from '@constants/locale';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const currentLanguage = getLanguageOption(i18n.language);

  const handleLanguageChange: NonNullable<MenuProps['onClick']> = ({ key }) => {
    i18n.changeLanguage(key);
    localStorage.setItem('gowarehouse_language', key);
  };

  const menuItems: NonNullable<MenuProps['items']> = LANGUAGE_OPTIONS.map(lang => ({
    key: lang.key,
    label: (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', minWidth: '120px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span>{lang.flag}</span>
          <span>{lang.label}</span>
        </div>
        {i18n.language === lang.key && (
          <CheckOutlined style={{ color: '#1890ff', marginLeft: '8px' }} />
        )}
      </div>
    )
  }));

  return (
    <Dropdown
      menu={{
        items: menuItems,
        onClick: handleLanguageChange,
        selectedKeys: [i18n.language]
      }}
      placement="bottomRight"
      trigger={['click']}
    >
      <Button
        type="text"
        className="admin-header-icon language-switcher"
        title="切換語言 / Switch Language"
      >
        <GlobalOutlined />
        <span style={{ marginLeft: '6px' }}>
          {currentLanguage.shortLabel}
        </span>
        <DownOutlined style={{ fontSize: '10px', marginLeft: '4px' }} />
      </Button>
    </Dropdown>
  );
};

export default LanguageSwitcher;
